import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';

export interface DeviationTypeRequestParam {
    id: number;
    name: string;
    createdOn: string;
    statusId: number;
    status: string;
}

@Injectable()
export class DeviationTypeService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }

    // fetch All Deviation Type
    getAllDeviationType(pageNumber: any, limit: any, s: any): Observable<any> {
        const me = this;
        const deviationListSubject = new Subject<any>(); // Will use this subject to emit data that we want
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        params = params.append('s', '0');
        me.apiRequest.get(this.appConfig.deviation_type_url, params).subscribe(jsonResp => {
            const items = jsonResp.data.map(function (v) {
                return Object.assign({}, v, {
                    id: `${v.id}`,
                    name: `${v.name}`,
                    statusId: `${v.statusId}`,
                    status: `${v.status}`,
                   });
            });

            const deviationObj = Object.assign({}, jsonResp, {
                data: items
            });
            deviationListSubject.next(deviationObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
        return deviationListSubject;
    }
// get notification history  via user id
    getNotificationHistoryByUserId(id: any, pageNumber: any, limit: any) {
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        return this.apiRequest.get(this.appConfig.users_url + '/' + id + '/deviations', params)
    }
    getColdStoreDetailsById(pageNumber: any, limit: any, id: any): Observable<any> {
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        return this.apiRequest.get(this.appConfig.cold_store_url + '/' + id + '/data/', params);
    }

}
